import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";

export default function CentroCultutal(){

  return(

    <>
    <Helmet title="Centro Cultural de Parauapebas - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="CENTRO CULTURAL DE PARAUAPEBAS" link1={"Projetos/ "} link2={"CENTRO CULTURAL DE PARAUAPEBAS"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                   Centro Cultural de Parauapebas
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Gestão, coordenação, operacionalização e manutenção do Centro Cultural em Parauapebas – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Parauapebas - PA</li>
                  <li><strong>Ano: </strong> 2018 </li>
                  <li><strong>Segmento: </strong> Facilities </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}